module.exports = __webpack_public_path__ + "img/ic_mpe_footsock_press.e0f3f9cd.png";